var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.59 4.125)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.734,
    height: 13.781,
    y: 1.969,
    stroke: "#4A4A4A",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    rx: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    d: "M.243 6.208h16.661"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4A4A4A",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M3.938 0v3.944M12.797 0v3.944"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.797,
    cy: 11.813,
    r: 1,
    fill: "#4A4A4A"
  })))));
}
export default SvgCalenderGrey;